import React from 'react';

/**
 * Consistent page header — presentation only.
 */
export default function PageHeader({
    title,
    description,
    eyebrow,
    actions,
    breadcrumb,
    className = ''
}) {
    return (
        <header className={`page-header animate-fade-up ${className}`}>
            {breadcrumb && (
                <p className="mb-2 text-xs font-medium uppercase tracking-wider text-ink-500">
                    {breadcrumb}
                </p>
            )}
            {eyebrow && (
                <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-brand-700">
                    {eyebrow}
                </p>
            )}
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0">
                    <h1 className="page-title">{title}</h1>
                    {description && <p className="page-subtitle">{description}</p>}
                </div>
                {actions && (
                    <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>
                )}
            </div>
        </header>
    );
}
